import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Radio,
  Input,
  Select,
  Modal,
  message,
  Spin
  // Checkbox
} from 'antd';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import styles from '../styles.module.less';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  delete_account,
  settings_account,
  activate_account
} from '../redux/slice';
// import Privacy from './Privacy';

const Settings = ({ country_codes, Settings_user, sendrequestLoading }) => {
  console.log('Settings_user', Settings_user);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [privacy, setPrivacy] = useState(false);
  const [isAccountActive, setIsAccountActive] = useState(true);
  // const [isPrivacy, setPrivacys] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openSections, setOpenSections] = useState({
    account: true,
    phone: true,
    privacy: true,
    emailNotifications: true,
    deleteAccount: true,
    disableAccount: true
  });
  // console.log(isPrivacy);

  // console.log('isAccountActive', isAccountActive);
  console.log('sendrequestLoading', sendrequestLoading);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleFormSubmit = async () => {
    setLoading(true);
    const values = form.getFieldsValue(); // Retrieve all form values
    console.log('values', values);
    // const user_name = values.user_name || '';
    // const user_email = values.user_email || '';
    // const current_phone_country_code_id = values.current_phone_country_code_id || '';
    const current_phone_number = values.current_phone_number || '';
    const new_phone_country_code_id = values.new_phone_country_code_id || '';
    const new_phone_number = values.new_phone_number || '';
    const is_private = values.is_private || '';
    const email_summary = values.email_summary === 'Yes' ? 'Yes' : 'No';
    const newsletters_permissions =
      values.newsletters_permissions === true ? 'Yes' : 'No';

    const payload = {
      // user_name: user_name,
      // user_email: user_email,
      current_phone_number: current_phone_number,
      new_phone_country_code_id: new_phone_country_code_id,
      new_phone_number: new_phone_number,
      is_private: is_private,
      email_summary: email_summary,
      newsletters_permissions: newsletters_permissions
    };

    const response = await dispatch(settings_account(payload));
    console.log('response', response?.payload);
    if (response?.payload?.success) {
      message.success(
        response?.payload?.message || 'Settings updated successfully!'
      );
      navigate(`/dashboard`);
      form.resetFields(); // Reset form fields after successful submission
    } else {
      message.error(
        response?.payload?.message ||
          'Failed to update settings. Please try again.'
      );
    }
    setLoading(false);
  };

  const confirmDeleteAccount = () => {
    Modal.confirm({
      title: (
        <span className={styles.modalTitle}>
          Are you sure you want to delete your account?
        </span>
      ),
      content: (
        <p className={styles.modalContent}>
          This action is <strong>irreversible</strong>. <br />
          All your data and content will be permanently removed.
        </p>
      ),
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      okButtonProps: {
        type: 'primary',
        danger: true,
        className: `${styles.deletedButton} ${styles.importantMargin}`
        // className: styles.saveButton
      },
      cancelButtonProps: {
        type: 'default', // Default Ant Design button style (gray)
        className: styles.cancelButton
      },
      onOk() {
        handleDeleteAccount();
      }
    });
  };

  const confirmDisableAccount = () => {
    Modal.confirm({
      title: (
        <span className={styles.modalTitle}>Deactivate Your Account?</span>
      ),
      content: (
        <div className={styles.modalContent}>
          <p>
            Are you sure you want to deactivate your profile? You will no longer
            be visible to others on the platform.
          </p>
          <p style={{ fontWeight: 'bold', color: '#faad14' }}>
            Note: Your data will be safely stored and you can reactivate your
            account at any time in the future.
          </p>
        </div>
      ),
      okText: 'Deactivate',
      okType: 'danger',
      cancelText: 'Cancel',
      okButtonProps: {
        type: 'primary',
        danger: true,
        className: styles.deletedButton
      },
      cancelButtonProps: {
        type: 'default',
        className: styles.cancelButton
      },
      onOk() {
        handleDeactiveAccount();
      }
    });
  };

  const confirmActivateAccount = () => {
    Modal.confirm({
      title: (
        <span className={styles.modalTitle}>Reactivate Your Account?</span>
      ),
      content: (
        <div className={styles.modalContent}>
          <p>
            Are you sure you want to reactivate your profile? You will become
            visible to others on the platform again.
          </p>
          <p style={{ fontWeight: 'bold', color: '#52c41a' }}>
            Welcome back! You can now continue connecting with others.
          </p>
        </div>
      ),
      okText: 'Reactivate',
      okType: 'primary',
      cancelText: 'Cancel',
      okButtonProps: {
        type: 'primary',
        className: styles.activateButton // Optional: create a green button style
      },
      cancelButtonProps: {
        type: 'default',
        className: styles.cancelButton
      },
      onOk() {
        handleActivateAccount(); // You need to create this function just like handleDeactiveAccount
      }
    });
  };

  const handleDeleteAccount = () => {
    // const accessToken = JSON.parse(
    //   localStorage.getItem('MAT-User')
    // )?.accessToken;

    // let payload = {
    //   token: accessToken
    // };
    // console.log('payload', payload);
    const payload = { type: 'delete' };
    dispatch(delete_account(payload));
  };

  const handleDeactiveAccount = () => {
    const payload = { type: 'deactivate' };
    dispatch(delete_account(payload));
  };

  const handleActivateAccount = () => {
    const payload = { type: 'activate' };
    dispatch(activate_account(payload));
  };

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const email = matUserObject.user_details.email;
  const fname = matUserObject.user_details.first_name;
  const lname = matUserObject.user_details.last_name;
  // const phone_num = matUserObject.user_details.phone_number;
  const phone_num = Settings_user?.phone_number;
  const profile_id = matUserObject.user_details.profile_unique_id;

  form.setFieldsValue({ new_phone_number: phone_num });

  useEffect(() => {
    form.setFieldsValue({ user_name: `${fname} ${lname}` });
    form.setFieldsValue({ user_email: email });
    form.setFieldsValue({ current_phone_country_code_id: '' });
    // form.setFieldsValue({ current_phone_number: phone_num });
    form.setFieldsValue({
      is_profile_active: Settings_user?.isAccountActive ? 'true' : 'false'
    });
  }, []);

  form.setFieldsValue({
    current_phone_number: Settings_user?.phone_number
  });
  form.setFieldsValue({
    is_private: Settings_user?.is_private
  });
  form.setFieldsValue({
    email_summary: Settings_user?.email_summary
  });
  form.setFieldsValue({
    newsletters_permissions: Settings_user?.newsletters_permissions === 'Yes'
  });
  // form.setFieldsValue({ is_profile_active: Settings_user?.is_profile_active });

  // const is_profile_active = isAccountActive;
  console.log(
    'Settings_user?.newsletters_permissions',
    Settings_user?.newsletters_permissions
  );

  const navigateToDashboard = () => {
    window.location.href = '/dashboard';
  };
  console.log('isAccountActive', isAccountActive);
  return (
    <div className={styles.container}>
      <button className={styles.primaryButton} onClick={navigateToDashboard}>
        Back
      </button>

      <div className={styles.outerBox}>
        <div className={styles.leftBox}>
          <h1 className={styles.leftHeader}>Settings</h1>
          <div
            className={`${styles.leftContent} ${!privacy ? styles.active : ''}`}
            onClick={() => {
              setPrivacy(false);
              // setPrivacys(false);
            }}
          >
            Account
          </div>
          {/* <div
            className={`${styles.leftContent} ${privacy ? styles.active : ''}`}
            onClick={() => {
              setPrivacy(true);
              setPrivacys(false);
            }}
          >
            Privacy
          </div> */}
        </div>
        {/* {privacy ? (
          <Privacy />
        ) : ( */}
        <div className={styles.rightBox}>
          <div className={styles.rightBoxInner}>
            <Form
              form={form}
              layout="vertical"
              className={styles.feedback_form}
              // style={{ fontFamily: 'teachers' }}
              // onFinish={handleFormSubmit}
              // initialValues={{
              //   name: 'Sanjana Choudary',
              //   email: 'sanjanac123@gmail.com',
              //   messagePermission: 'anyone',
              //   emailSummary: 'yes',
              //   newsletters: ['Accept_Announcements']
              // }}
            >
              {/* Account Details */}
              <div className={styles.accountContainer}>
                <div
                  className={`${styles.accountHeader} ${
                    openSections.account ? styles.active : ''
                  }`}
                  onClick={() => toggleSection('account')}
                >
                  <span>Account Information</span>
                  {openSections.account ? (
                    <FaChevronUp className={styles.accountIcon} />
                  ) : (
                    <FaChevronDown className={styles.accountIcon} />
                  )}
                </div>
                {openSections.account && (
                  <div className={styles.accountContent}>
                    <div className={styles.accountRow}>
                      <div>
                        <label style={{ fontSize: '12px' }}>Name</label>
                        <div className={styles.underBorder}></div>
                        <Form.Item
                          name="user_name"
                          initialValue={`${fname} ${lname}`}
                          noStyle
                        >
                          <div className={styles.rightData}>
                            {/* Sanjana Choudary */}
                            {fname} {lname}
                          </div>
                        </Form.Item>
                      </div>
                      <div>
                        <label style={{ fontSize: '12px' }}>Email ID</label>
                        <div className={styles.underBorder}></div>
                        <Form.Item name="user_email" noStyle>
                          <div className={styles.rightData}>
                            {/* sanjanac123@gmail.com */}
                            {email}
                          </div>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/** Phone number change */}

              <div className={styles.accountContainer}>
                <div
                  className={`${styles.accountHeader} ${
                    openSections.phone ? styles.active : ''
                  }`}
                  onClick={() => toggleSection('phone')}
                >
                  <span>Change of Phone Number</span>
                  {openSections.phone ? (
                    <FaChevronUp className={styles.accountIcon} />
                  ) : (
                    <FaChevronDown className={styles.accountIcon} />
                  )}
                </div>
                {openSections.phone && (
                  <div className={styles.accountContent}>
                    <div className={styles.accountRow1}>
                      <div>
                        <label style={{ fontSize: '12px' }}>
                          Current Phone Number
                        </label>
                        <div className={styles.underBorder}></div>
                        <Form.Item name="current_phone_number" noStyle>
                          <div className={styles.rightData}>
                            {/* 7995681727 */}
                            {phone_num}
                          </div>
                        </Form.Item>
                      </div>
                      <div>
                        {/* <label>New Mobile Number</label> */}
                        {/* <div className={styles.underBorder}></div> */}
                        {/* <Form.Item name="nphone" noStyle>
                         
                          <Input placeholder="enter your New Phone number" />
                        </Form.Item> */}
                        <Form.Item
                          label="Phone Number"
                          required
                          // name="phone"
                          // rules={[
                          //   { required: true, message: 'Please enter your phone number' }
                          // ]}
                          style={{ display: 'block' }}
                        >
                          <Input.Group
                            compact
                            className={styles.customInputContainer}
                          >
                            <Form.Item
                              name="new_phone_country_code_id"
                              noStyle
                              // initialValue="+91"
                              initialValue={1}
                            >
                              <Select
                                style={{ width: '30%' }}
                                showSearch
                                placeholder="Select country code"
                                className="custom-select"
                                optionFilterProp="children"
                                getPopupContainer={(triggerNode) =>
                                  triggerNode.parentNode
                                } // Ensures correct styling
                                dropdownStyle={{ borderRadius: '8px' }} // Apply radius to dropdown
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {country_codes?.length
                                  ? country_codes?.map((code, index) => {
                                      return (
                                        <option value={code?.id} key={index}>
                                          {code?.country_code}
                                        </option>
                                      );
                                    })
                                  : ''}
                              </Select>
                            </Form.Item>
                            <span className={styles.divider}>|</span>
                            <Form.Item
                              name="new_phone_number"
                              noStyle
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter a valid phone number'
                                },
                                {
                                  pattern: /^[0-9]{10}$/,
                                  message:
                                    'Phone number must be up to 10 digits'
                                }
                              ]}
                            >
                              <Input
                                placeholder="Enter phone number"
                                type="tel"
                                maxLength={10}
                              />
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Privacy Section */}
              <div className={styles.accountContainer}>
                <div
                  className={`${styles.accountHeader} ${
                    openSections.privacy ? styles.active : ''
                  }`}
                  onClick={() => toggleSection('privacy')}
                >
                  <span>Privacy</span>
                  {openSections.privacy ? (
                    <FaChevronUp className={styles.accountIcon} />
                  ) : (
                    <FaChevronDown className={styles.accountIcon} />
                  )}
                </div>
                {openSections.privacy && (
                  <div className={styles.accountContent}>
                    <div className={styles.accountRow}>
                      <div>
                        <div style={{ fontSize: '12px' }}>
                          Users who can message you directly
                        </div>
                        <div className={styles.underBorder}></div>
                        <Form.Item name="is_private">
                          <Radio.Group>
                            <Radio className={styles.rightData} value="Anyone">
                              Anyone
                            </Radio>
                            <Radio
                              className={styles.rightData}
                              value="Only on request"
                              style={{ marginLeft: '15px' }}
                            >
                              Only on request
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Email Notifications Section */}
              <div className={styles.accountContainer}>
                <div
                  className={`${styles.accountHeader} ${
                    openSections.emailNotifications ? styles.active : ''
                  }`}
                  onClick={() => toggleSection('emailNotifications')}
                >
                  <span>Email Notifications</span>
                  {openSections.emailNotifications ? (
                    <FaChevronUp className={styles.accountIcon} />
                  ) : (
                    <FaChevronDown className={styles.accountIcon} />
                  )}
                </div>
                {openSections.emailNotifications && (
                  <div className={styles.accountContent}>
                    <div className={styles.accountRow}>
                      <div>
                        <label style={{ fontSize: '12px' }}>
                          Receive an email summary of notifications instead of
                          individual emails
                        </label>
                        <div className={styles.underBorder}></div>
                        <Form.Item name="email_summary">
                          <Radio.Group>
                            <Radio className={styles.rightData} value="Yes">
                              Yes
                            </Radio>
                            <Radio
                              className={styles.rightData}
                              style={{ marginLeft: '15px' }}
                              value="No"
                            >
                              No
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                      {/* <div>
                        <label style={{ fontSize: '12px' }}>
                          Newsletters I would like to receive:
                        </label>
                        <div className={styles.underBorder}></div>
                        <Form.Item
                          name="newsletters_permissions"
                          valuePropName="checked"
                          style={{ marginTop: '-10px' }}
                        >
                          <Checkbox className={styles.rightData}>
                            Announcements and special offers (Rarely)
                          </Checkbox>
                        </Form.Item>
                      </div> */}
                    </div>
                  </div>
                )}
              </div>
              {/*  Disable Account*/}
              <div className={styles.accountContainer}>
                <div
                  className={`${styles.accountHeader} ${
                    openSections.disableAccount ? styles.active : ''
                  }`}
                  onClick={() => toggleSection('disableAccount')}
                >
                  {/* <span>Deactivate Account</span> */}
                  <span>Deactivate/ Reactivate Account </span>
                  {openSections.disableAccount ? (
                    <FaChevronUp className={styles.accountIcon} />
                  ) : (
                    <FaChevronDown className={styles.accountIcon} />
                  )}
                </div>
                {openSections.disableAccount && (
                  <div className={styles.accountContent1}>
                    <div className={styles.accountDelete}>
                      <div>
                        <div className={styles.deleteContent}>
                          {/* Would you like to deactivate your account:{' '} */}
                          Would you like to{' '}
                          {isAccountActive ? 'deactivate' : 'reactivate'} your
                          account:
                          <b>
                            {/* {fname} {lname} ( {email}){' '} */}
                            {profile_id}
                          </b>
                          <br />
                          Disabling will temporarily make your account inactive
                          perfect if you&apos;re exploring a potential
                          connection and want to pause seeing or being seen by
                          other matches.{' '}
                        </div>
                        <div
                          className={styles.deleteButton}
                          onClick={() => {
                            if (Settings_user?.is_profile_active) {
                              confirmDisableAccount(); // Function to deactivate the account
                            } else {
                              confirmActivateAccount(); // Function to activate the account
                            }
                            setIsAccountActive(!isAccountActive); // Toggle the account state after clicking
                          }}
                          loading={sendrequestLoading}
                          disabled={sendrequestLoading}
                        >
                          {/* {Settings_user?.is_profile_active || !isAccountActive
                            ? 'I want to deactivate my Account'
                            : 'I want to activate my Account'} */}
                          {sendrequestLoading ? (
                            <Spin size="small" /> // Show spinner when loading
                          ) : Settings_user?.is_profile_active ||
                            !isAccountActive ? (
                            'I want to deactivate my account'
                          ) : (
                            'I want to activate my account'
                          )}
                        </div>
                        {/* </Form.Item> */}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* Delete My Account Section */}
              <div className={styles.accountContainer}>
                <div
                  className={`${styles.accountHeader} ${
                    openSections.deleteAccount ? styles.active : ''
                  }`}
                  onClick={() => toggleSection('deleteAccount')}
                >
                  <span>Delete Account</span>
                  {openSections.deleteAccount ? (
                    <FaChevronUp className={styles.accountIcon} />
                  ) : (
                    <FaChevronDown className={styles.accountIcon} />
                  )}
                </div>
                {openSections.deleteAccount && (
                  <div className={styles.accountContent1}>
                    <div className={styles.accountDelete}>
                      <div>
                        <div className={styles.deleteContent}>
                          Would you like to delete your account:{' '}
                          <b>
                            {/* {fname} {lname} ( {email}){' '} */}
                            {profile_id}
                          </b>
                          <br />
                          Deleting your account will remove all of your content
                          and data associated with your marriage profile. This
                          action will delete your account. To see all associated
                          information, please visit{' '}
                          <u>
                            <a
                              href="https://elite.lexyslabs.com/privacy-policy"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              https://elite.lexyslabs.com/privacy-policy
                            </a>
                          </u>{' '}
                          or contact :{' '}
                          <a href="mailto:info@samskrutimatrimony.com">
                            info@samskrutimatrimony.com.
                          </a>
                        </div>
                        {/* <Form.Item name="confirmDelete"> */}
                        <div
                          className={styles.deleteButton}
                          // onClick={handleDeleteAccount}
                          onClick={confirmDeleteAccount}
                        >
                          I want to delete my account
                        </div>
                        {/* </Form.Item> */}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Submit Button - Add this for form submission */}
              {/* <Form.Item> */}
              <Button
                type="primary"
                htmlType="submit"
                className={styles.saveButton}
                onClick={handleFormSubmit}
                loading={loading}
                disabled={loading} // Disable button while loading
              >
                Save Changes
              </Button>
              {/* </Form.Item> */}
            </Form>
          </div>
        </div>
        {/* // )} */}
      </div>
    </div>
  );
};

export default Settings;
